import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc, {d3} from 'dc';
import * as chartsUtilFunctions from './util/chartsUtilFunctions';
import * as utilFunctions from './util/utilFunctions';
import CrossfilterBase from './crossfilterBase';
import $ from "jquery";
 
class BaseChart extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      crossfilter: new CrossfilterBase(props),
      chart: null,
      config: {
          group: "ALL",
          colors: [
            "#2574A9","#22A7F0","#65C6BB","#BBC60A","#F9BF3B","#F9690E",
            "#11C638","#8DD593","#C6DEC7","#EAD3C6","#F0B98D","#EF9708",
            "#023FA5","#7D87B9","#BEC1D4","#D6BCC0","#BB7784","#FFFFFF",                
            "#0FCFC0","#9CDED6","#D5EAE7","#F3E1EB","#F6C4E1","#F79CD4"],          
          tooltip: {
            lines:"NONE", 
            show: true,
            valuesConfig: [],
            dashboardLinkConfig: utilFunctions.getDashboardLinkConfigDefault(),
            onlyExtraInfoLinked: true
          },
        },
      width: 0,
      height: 0,
      extraClass: "",
      tooltipObjectClass: "",
      tooltipFormatFunction: null,
      resizeFunctionId: null
    }; 
    this.handleResize = this.handleResize.bind(this);
    this.handleResizeController = this.handleResizeController.bind(this);
    this.postRenderOperations = this.postRenderOperations.bind(this);
    this.preRenderOperations = this.preRenderOperations.bind(this);
  }

  getChartTypeInstance() {
    throw "Method getChartTypeInstance() must be implemented and return a dc.chart (composite, line or bar)";
  }

  setSize() {
    this.state.chart
      .width(this.state.width)
      .height(this.state.height);
  }

  initializeBasicChartConfig()
  {
    this.state.config = chartsUtilFunctions.setConfigParams(this.props.config, this.state.config);
    this.state.chart = this.getChartTypeInstance();    
    this.setSize();
    this.state.chart
      .dimension(this.state.crossfilter.getDim());
    this.state.chart.transitionDuration(0);
    this.state.chart.onClick = function() {};
    this.state.chart.filter = function() {};
    this.state.chart.on('postRender', (function() { 
      this.postRenderOperations(); 
      d3.select(this.refs.containerDivDom).classed("showComponent",true);     
    }).bind(this));
    this.state.chart.on('preRender', (function() { 
      d3.select(this.refs.containerDivDom).classed("showComponent",false);
      this.preRenderOperations();
    }).bind(this));

    this.state.chart.on('postRedraw', (function() { 
      this.postRenderOperations();    
    }).bind(this));
    this.state.chart.on('preRedraw', (function() { 
      this.preRenderOperations();
    }).bind(this));

    this.setMetrics();

    this.state.tooltipFormatFunction = this.getTooltipFormatFunction();
  }

  setMetrics() {
      throw "Method setMetric(metric) must be implemented";
  }

  stylingAndFormat() {
    throw "Method stylingAndFormat() must be implemented";  
  }

  getTooltipFormatFunction() {
    var wrapValueFunction = utilFunctions.wrapValue;
    var getColorPropsFunction = chartsUtilFunctions.getColorProps;
    var colorWrapValueFunction = chartsUtilFunctions.colorWrapValue;
    var formatFunctions = [];
    var defaultConfig = {
      identifier: null,
      noDataInfo: null,
      wrapper: "%v",
      valueFormat: utilFunctions.getValueFormatDefault(),
      colorRangeParser: [],
      colorRange:[],
    };
    
    for(var i=0;i<this.state.config.tooltip.valuesConfig.length;i++) {
      var valueConfig = chartsUtilFunctions.setConfigParams(this.state.config.tooltip.valuesConfig[i], defaultConfig); 
      var format = utilFunctions.getFormatFunction(valueConfig.valueFormat);
      var wrapper = valueConfig.wrapper;

      if(valueConfig.identifier!=null) {
        formatFunctions[i] = (function (_valueConfig,_format,_wrapper,d) {
            var value;
            if(_valueConfig.identifier=="key") {
              value = d.data.key;
              if(value == "Others") {
                value = "Otros";
              }
            }
            else if(_valueConfig.identifier=="dataValue") {
              value = d.data.value.value;
            }
            else if(_valueConfig.identifier=="piePercentage") {
              value = Math.abs(d.endAngle - d.startAngle)/(2*Math.PI);
            }
            else if(_valueConfig.identifier=="extraInfo") {
              if(("extraInfo" in d)==false) {
                return "";
              }
              var returnString = "";
              for(var i=0; i<d.extraInfo.length;i++) {
                var extraInfoItem = d.extraInfo[i];
                var extraInfoItemWrapper = "<div><span>"+extraInfoItem.name+": </span><span>%v</span></div>";
                var formatFunction = _format;
                var colorRange = _valueConfig.colorRange;
                var colorRangeParser = _valueConfig.colorRangeParser;
                
                if("valueFormat" in extraInfoItem.config) {
                  formatFunction = utilFunctions.getFormatFunction(extraInfoItem.config.valueFormat);
                }

                if("colorRange" in extraInfoItem.config) {
                  colorRange = extraInfoItem.config.colorRange;
                  colorRangeParser = extraInfoItem.config.colorRangeParser || [];
                }
                
                var colorProps = getColorPropsFunction(colorRange, extraInfoItem.value, colorRangeParser);
                var formatValue = formatFunction(extraInfoItem.value);
                returnString+=colorWrapValueFunction(colorProps,wrapValueFunction(extraInfoItemWrapper,formatValue));
              }
              return wrapValueFunction(_wrapper,returnString);
            }
            else {
              value = d[_valueConfig.identifier];
              //hack rapido para esconder valores, revisar hacerlo de otra forma (en workday chart lo uso)
              if(value=="HIDE") {
                return "";
              }
            }
            
            if (value==null && _valueConfig.noDataInfo) {
              return _valueConfig.noDataInfo;
            }

            var colorProps = getColorPropsFunction(_valueConfig.colorRange, value, _valueConfig.colorRangeParser);
            var formatValue = _format(value);
            return colorWrapValueFunction(colorProps,wrapValueFunction(_wrapper,formatValue));
        }).bind(this,valueConfig,format,wrapper)
      }
    }

    return (function (_formatFunctions,d) {
          var output = "";
          for(var i=0;i<_formatFunctions.length;i++) {
            output = output + (_formatFunctions[i])(d);
          }
          return output;
        }).bind(this,formatFunctions)
  }

  applyToolTips(svgChart, removeMouseOut = true) {
    var wrapValueFunction = utilFunctions.wrapValue;
    svgChart.selectAll(this.state.tooltipObjectClass + " title").remove();

    if(svgChart) {
      svgChart.selectAll(this.state.tooltipObjectClass).on("mouseover",null);
      svgChart.selectAll(this.state.tooltipObjectClass).on("mouseleave",null);
      if(removeMouseOut) {
        svgChart.selectAll(this.state.tooltipObjectClass).on("mouseout",null);
      }
      svgChart.selectAll(this.state.tooltipObjectClass).on("click",null);
    }

    if(d3.select("#pageTooltip").empty() == false 
        && this.state.tooltipObjectClass != ""
        && this.state.config.tooltip.show == true) {
      var tooltipText = d3.select("#pageTooltip .tooltip-inner");
      var tooltip = d3.select("#pageTooltip");
      var _this = this;

      svgChart.selectAll(this.state.tooltipObjectClass)
        .each(function(d) {
          var tooltipElement = d3.select(this);
          tooltipElement   
            .on("mouseover", function(d,_element = null) { 
                var elementeRect;
                var toolTipRect;
                var toolTipTop = 0;
                var toolTipLeft = 0;
                var totalWidth = $("body").width();
                elementeRect = d3.event.target.getBoundingClientRect();
                var element = d3.select(d3.event.target);
                             
                if(typeof _element == "object") {
                  elementeRect = _element.node().getBoundingClientRect();
                  element = _element;
                }
                
                tooltip.classed("left", false);
                tooltip.classed("bottom", false); 
                tooltip.classed("top", true);   
                
                tooltipText.html(_this.state.tooltipFormatFunction(d));
                toolTipRect = tooltip[0][0].getBoundingClientRect();  
                toolTipLeft = (elementeRect.left + elementeRect.width/2) - toolTipRect.width/2;            
                toolTipTop = (elementeRect.top) - (toolTipRect.height) - 1;
                if(toolTipLeft + toolTipRect.width >= totalWidth) {
                  tooltip.classed("left", true); 
                  tooltip.classed("top", false);
                  toolTipRect = tooltip[0][0].getBoundingClientRect();
                  toolTipLeft = (elementeRect.left - toolTipRect.width) - 4;            
                  toolTipTop = (elementeRect.top) - (toolTipRect.height/2) - 1 + elementeRect.width/2;                                   
                }
                else if(toolTipTop<=0) {
                  tooltip.classed("left", false); 
                  tooltip.classed("top", false);
                  tooltip.classed("bottom", true);
                  toolTipRect = tooltip[0][0].getBoundingClientRect();          
                  toolTipTop = (elementeRect.top) + elementeRect.height + 4;    
                }      

                tooltip
                  .style("left", (toolTipLeft) + "px")     
                  .style("top", (toolTipTop) + "px");
                 
                tooltip.classed("in", true); 
                element.classed("hover", true);                 
            })                  
            .on("mouseleave", function(d,_element = null) { 
                var element = d3.select(d3.event.target);                             
                if(typeof _element == "object") {
                  element = _element;
                }      
                tooltip.classed("in", false); 
                element.classed("hover", false);   
            });
            
          /*if(_this.state.config.tooltip.dashboardLinkConfig.dashboard_id != null &&
              (_this.state.config.tooltip.onlyExtraInfoLinked == false 
                  || tooltipElement.classed("extraInfoTooltip")==true)) {
            tooltipElement.classed("linkTooltip", true);
            d.clickElement = new DashboardLink({
              config: {
                where: _this.state.config.tooltip.dashboardLinkConfig.where,
                serializedParams: wrapValueFunction(_this.state.config.tooltip.dashboardLinkConfig.serializedParams,+d.x),
                dashboard_id: _this.state.config.tooltip.dashboardLinkConfig.dashboard_id
              },
              dispatch: _this.props.dispatch
            },this.context);
            tooltipElement
              .on("click", function(d) {
                d.clickElement.onClick();
              });
          }*/      
        });      
    }    
  }

  postRenderOperations() {
    this.state.chart.svg().select('defs clippath').remove();
    this.applyToolTips(this.state.chart.svg());
  }

  preRenderOperations() {

  }

  makeChart() { 
    this.state.crossfilter.processCrossfilter();
    this.initializeBasicChartConfig();
    this.stylingAndFormat();
  }

  componentDidMount() {
    this.state.width = this.refs.containerDivDom.clientWidth;
    this.state.height = this.refs.containerDivDom.clientHeight;
    this.renderOrRedraw();
    
    window.addEventListener('resize', this.handleResizeController);
  } 

  componentDidUpdate() {
    this.renderOrRedraw();
  }

  renderOrRedraw() {
    if(this.state.chart==null) {
      this.makeChart();
      this.state.chart.render();
    }
    else {
      this.setSize();      
      this.state.chart.render();
    }    
  }

  handleResize() {
    this.setState({
      width: this.refs.containerDivDom.clientWidth,
      height: this.refs.containerDivDom.clientHeight,
    });      
  }

  handleResizeController() {
    if(this.state.resizeFunctionId != null) {   
      clearTimeout(this.state.resizeFunctionId);
    }
    else {
      d3.select(this.refs.containerDivDom).classed("showComponent",false);
    }
    this.state.resizeFunctionId = setTimeout((function(){      
      this.handleResize();
      this.state.resizeFunctionId = null;
    }).bind(this), 500);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResizeController);
    if(this.state.chart != null && typeof this.state.chart.svg != "undefined" && this.state.chart.svg() != null) {
      this.state.chart.svg().selectAll(this.state.tooltipObjectClass).on("mouseover",null);
      this.state.chart.svg().selectAll(this.state.tooltipObjectClass).on("mouseleave",null);
      this.state.chart.svg().selectAll(this.state.tooltipObjectClass).on("mouseout",null);
      this.state.chart.svg().selectAll(this.state.tooltipObjectClass).on("click",null);
      this.state.chart.svg().on("zoom", null).on("zoomstart", null).on("zoomend", null);
    }

    if(this.state.chart != null && typeof this.state.chart.on != "undefined") {
      this.state.chart.on('postRender', null);
      this.state.chart.on('preRender', null);
      this.state.chart.on('postRedraw', null);
      this.state.chart.on('preRedraw', null);
      this.state.chart.on('filtered', null);
      this.state.chart.on('zoomed', null);
      this.state.chart.on('renderlet', null);
      this.state.chart.on('pretransition', null);
      dc.chartRegistry.deregister(this.state.chart);
    }
  } 

  render() {
    return (
      <div 
        className={"animateOnLoad autoResizeComponent " + this.state.extraClass} 
        ref="containerDivDom" 
        id={this.props.id}>
      </div>
    );
  }
}


export default BaseChart;


// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/baseChart.jsx